import React from 'react'
import { Button } from 'hhsoig-design-system-core'

export const ReturnButton = () => {
  return (
    <Button
      variation="secondary"
      data-testid="return-hotline"
      href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
    >
      Return to HHS-OIG Hotline
    </Button>
  )
}
